<template>
  <div class="validate-user" :class="[cssType, { 'has-design-title': designTitle }]">
    <div class="section-head artwork-head">
      <img v-if="designTitle" class="design-title" :src="designTitle" :alt="$t('novShopping.verify.title')" />
      <template v-else>
        <img class="part-watermark" :src="partWatermark" alt="" />
        <div class="title-row">
          <img class="gift" :src="giftImg" alt="" />
          <img v-if="titleImg" class="main-title" :src="titleImg" :alt="$t('novShopping.verify.title')" />
        </div>
      </template>
    </div>

    <div class="form" v-if="!state.cpUserInfo.cpUserId">
      <button
        type="button"
        class="hint-icon"
        :aria-label="$t('payment.howToCheckUserId')"
        :title="$t('payment.howToCheckUserId')"
        @click="openUserGuide"
      >?</button>
      <span class="label" @click="openUserGuide">{{ $t('novShopping.verify.accountId') }}</span>
      <HistoryUserIdInput
        v-model="state.userId"
        :locale="state.locale"
        :placeholder="$t('novShopping.verify.placeholder')"
        class="input"
      />
      <div class="submit-btn" @click="handleActSubmit('novShopping')">
        {{ $t('novShopping.verify.login') }}
      </div>
    </div>

    <div class="success" v-else>
      <div class="user-info">
        <div class="user-line">
          <span class="label">{{ $t('novShopping.verify.accountId') }}</span>
          <span class="value">{{ state.cpUserInfo.cpUserId }}</span>
        </div>
        <div class="user-line">
          <span class="label">{{ $t('novShopping.verify.accountName') }}</span>
          <span class="value">{{ state.cpUserInfo.cpNickName }}</span>
        </div>
      </div>
      <div class="switch-btn" @click="resetUserInfo">
        {{ $t('novShopping.verify.switchAccount') }}
      </div>
    </div>

    <Dialog v-model="state.dialog.visible" :title="$t('novShopping.verify.confirm')">
      <div class="confirm-dialog">
        <div class="confirm-heading">{{ $t('novShopping.verify.confirm') }}</div>
        <div class="confirm-line">{{ state.tempCpUserInfo.cpUserId }}</div>
        <div class="confirm-line">{{ state.tempCpUserInfo.cpNickName }}</div>
        <div class="dialog-actions">
          <div class="action-btn plain" @click="handleCancel">{{ $t('novShopping.common.cancel') }}</div>
          <div class="action-btn primary" @click="handleConfirm">{{ $t('novShopping.common.confirm') }}</div>
        </div>
      </div>
    </Dialog>
    <ElImageViewer
      v-if="state.showImageViewer"
      hide-on-click-modal
      :url-list="state.imageList"
      :initial-index="0"
      :z-index="9999"
      teleported
      @close="closeImageViewer"
    />
  </div>
</template>

<script setup>
import { defineEmits, onUnmounted } from 'vue'
import { ElImageViewer } from 'element-plus'
import { isMobile } from '@/utils'
import useValidateUser from '@/components/ValidateUser/script'
import HistoryUserIdInput from '@/components/ValidateUser/HistoryUserIdInput/index.vue'
import Dialog from '../Dialog/index.vue'
import titleImg from '../../assets/imgs/validateUser/mainTitle/index.js'
import partWatermark from '../../assets/imgs/validateUser/part1-watermark.png'
import giftImg from '../../assets/imgs/goods/gift.png'
import { verifyTitle as designTitle } from '../../assets/imgs/sectionTitles'

const emit = defineEmits(['getUserInfoSuccess', 'resetUserInfo', 'dialogOpen'])

const cssType = isMobile ? 'mobile' : 'pc'

const { state, handleActSubmit, handleConfirm, handleCancel, resetUserInfo, openUserGuide, closeImageViewer } = useValidateUser(emit, 'novShopping')

onUnmounted(closeImageViewer)
</script>

<style lang="less" scoped src="./pc_style.less"></style>
<style lang="less" scoped src="./mobile_style.less"></style>
